# password/EditCtrl
PasswordEditCtrl = ($scope, $routeParams, $location, $filter, flash, PasswordService, AuthService) ->
  $scope.params = reset_password_token: $routeParams.reset_password_token
  $scope.isSubmitting = false
  $scope.passwordPattern = /^(?=.{10,}$)((?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*\d))|(?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*[!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[a-z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[A-Z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~])))[A-Za-z\d!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~]+$/

  $scope.submit = ->
    $scope.isSubmitting = true
    PasswordService.update($scope.params)
    .then (resp) ->
      flash.success $filter('translate')('API_SUCCESS')
      AuthService.signInBypass()
      $location.path('/')
    .catch (resp) ->
      flash.error $filter('translate')('API_ERROR')
    .finally ->
      $scope.isSubmitting = false

PasswordEditCtrl.$inject = [
  '$scope'
  '$routeParams'
  '$location'
  '$filter'
  'flash'
  'PasswordService'
  'AuthService'
]

module.exports = PasswordEditCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/password/edit-controller.coffee